module.exports = __webpack_public_path__ + "static/media/PM.24bafbc1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/PM.svg
// module id = 2241
// module chunks = 7